import { __assign } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { SplitPanelContext } from '../internal/context/split-panel-context';
export function SplitPanelWrapper(_a) {
    var context = _a.context, children = _a.children, isCopy = _a.isCopy;
    if (!children) {
        return null;
    }
    return React.createElement(SplitPanelContext.Provider, { value: __assign(__assign({}, context), { isCopy: isCopy }) }, children);
}
//# sourceMappingURL=split-panel-wrapper.js.map